export class UserTenant {
  tenantId: string;
  tenantName: string;
  roles: string[];
}
